import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import TemplateDetails from '../components/template-details';
import getLocale from '../modules/i18n/selectors/locale';
import user from '../modules/user';
import useTemplates from '../modules/templates/hooks/use-templates';
import routesMap from '../router/helpers/routes-map';
import { SiteSetupContext } from '../modules/site-setup/helpers/site-setup-context';
import getSiteIdToSwitch from '../modules/sites/selectors/site-id-to-switch-template';
import getSelectedTemplate from '../modules/templates/helpers/get-selected-template';

const TemplateDetailsContainer = () => {
  const navigate = useNavigate();
  const locale = useSelector(getLocale);
  const isUserAuthorized = user.verifiers.isUserAuthorized();
  const params = useParams();
  const { templateSlug } = params;
  const context = useContext(SiteSetupContext);
  const archetype = context.getArchetype();
  const isArchetypeSet = archetype !== undefined;
  const siteIdToSwitch = useSelector(getSiteIdToSwitch);
  const { templates } = useTemplates();

  if (isUserAuthorized && !templateSlug && !isArchetypeSet && !siteIdToSwitch) {
    navigate(routesMap.siteCategory.url(), { replace: true });
    return null;
  }

  if (!templates.length || !locale) {
    return null;
  }

  const selectedTemplate = getSelectedTemplate(templates, templateSlug);
  if (!selectedTemplate) {
    return null;
  }

  return (
    <>
      <TemplateDetails name={templateSlug} livePreviewUrl={selectedTemplate.livePreviewUrl} />
      <Outlet />
    </>
  );
};

export default TemplateDetailsContainer;
